import React from "react";
import ReactDOM from 'react-dom/client';
import {Toaster} from 'react-hot-toast';
import App from "./App";
import "./styles/globalStyles.css";
import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { VehicleProvider } from "./context/VehicleContext";

const persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <VehicleProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </VehicleProvider>
    </PersistGate>
  </Provider>
  <Toaster />
 </React.StrictMode>
   

);